export default {
    // 模块名称
    linkage: {
      // 按钮类
      button: {
        save: '保存',
        cancel: '取消',
        delete: '删除',
        create: '创建',
        query: '查询',
        reset: '重置',
        complete: '完成',
        add: '添加'
      },
      // 文字标签类
      label: {
        addDevice: '添加设备'
      }
    },
    task: {
      status: {
        CREATED: '已创建',
        PENDING_CREATE: '等待中',
        SCHEDULING: '调度中',
        CREATE_FAIL: '创建失败',
        PENDING_TERMINATED: '终止中',
        TERMINATED: '已终止',
        STARTING: '启动中',
        RUNNING: '运行中',
        SUCCEEDED: '运行成功',
        FAILED: '运行失败',
        PENDING_DELETE: '删除中',
        DELETE_FAIL: '删除失败',
        ABNORMAL: '运行异常',
      },
      label: {
        index: '序号',
        taskId: '任务编码',
        taskName: '任务名称',
        type: '选择源类型',
        keepTime: '图片保存时间',
        sendImgQuality: '图片质量',
        status: '作业状态',
        description: '任务描述',
        cameraList: '摄像机列表',
        createTime: '创建时间',
        day: '天',
        second: '秒',
        cameraId: '摄像机编码',
        lineCount: '开启过线计数',
        areaCount: '开启区域计数',
        heatDistribution: '开启热力分布',
        heatCircle: '热力更新周期',
        areaSetting: '区域列表',
        selection: '开始框选',
        resetSelection: '重新框选',
        personThreadHold: '最小人员数量',
        durationThreadhold: '离开持续时间（秒）',
        duration: '持续离开时间',
        operation: '操作'
      },
      placeholder: {
        type: '请选择源类型',
        select: '请选择',
        sendImgQuality: '请选择图片质量'
      }
    }
  }
  